module.exports = __webpack_public_path__ + "img/map-pin.d73908dd.svg";